// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accept-invite-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fa;
  padding: 24px;
}

.accept-invite-card {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  padding: 36px 32px;
  color: #1f2937;
}

.accept-invite-logo {
  display: block;
  margin: 0 auto 24px;
  height: 44px;
}

.accept-invite-card h1 {
  font-size: 22px;
  margin: 0 0 8px 0;
  text-align: center;
}

.accept-invite-card .accept-subtitle {
  color: #6b7280;
  text-align: center;
  margin: 0 0 24px 0;
  font-size: 14px;
}

.accept-invite-card .invite-summary {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #374151;
}

.accept-invite-card .invite-summary strong {
  color: #111827;
}

/* MUI TextFields handle their own labels/inputs. The legacy global
   \`label\` / \`input\` styling below would shrink them and break the
   floating-label outline, so we scope styling to legacy plain inputs
   only (none remain in the new-user form). */
.accept-invite-card form .MuiTextField-root {
  margin-top: 8px;
  margin-bottom: 8px;
}

.accept-invite-card form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #5616ea;
  border-width: 2px;
}

.accept-invite-card form .MuiInputLabel-root.Mui-focused {
  color: #5616ea;
}

.accept-invite-card .accept-button {
  width: 100%;
  background: #5616ea;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
}

.accept-invite-card .accept-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.accept-invite-card .accept-error {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
  padding: 10px 14px;
  border-radius: 6px;
  margin-top: 14px;
  font-size: 14px;
}

.accept-invite-card .accept-link {
  display: block;
  margin-top: 16px;
  text-align: center;
  font-size: 13px;
  color: #5616ea;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AcceptInvite.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;6CAG6C;AAC7C;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".accept-invite-page {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #f5f6fa;\r\n  padding: 24px;\r\n}\r\n\r\n.accept-invite-card {\r\n  width: 100%;\r\n  max-width: 520px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\r\n  padding: 36px 32px;\r\n  color: #1f2937;\r\n}\r\n\r\n.accept-invite-logo {\r\n  display: block;\r\n  margin: 0 auto 24px;\r\n  height: 44px;\r\n}\r\n\r\n.accept-invite-card h1 {\r\n  font-size: 22px;\r\n  margin: 0 0 8px 0;\r\n  text-align: center;\r\n}\r\n\r\n.accept-invite-card .accept-subtitle {\r\n  color: #6b7280;\r\n  text-align: center;\r\n  margin: 0 0 24px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.accept-invite-card .invite-summary {\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 14px 16px;\r\n  margin-bottom: 24px;\r\n  font-size: 14px;\r\n  color: #374151;\r\n}\r\n\r\n.accept-invite-card .invite-summary strong {\r\n  color: #111827;\r\n}\r\n\r\n/* MUI TextFields handle their own labels/inputs. The legacy global\r\n   `label` / `input` styling below would shrink them and break the\r\n   floating-label outline, so we scope styling to legacy plain inputs\r\n   only (none remain in the new-user form). */\r\n.accept-invite-card form .MuiTextField-root {\r\n  margin-top: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.accept-invite-card form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: #5616ea;\r\n  border-width: 2px;\r\n}\r\n\r\n.accept-invite-card form .MuiInputLabel-root.Mui-focused {\r\n  color: #5616ea;\r\n}\r\n\r\n.accept-invite-card .accept-button {\r\n  width: 100%;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 12px;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin-top: 20px;\r\n}\r\n\r\n.accept-invite-card .accept-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.accept-invite-card .accept-error {\r\n  background: #fef2f2;\r\n  color: #991b1b;\r\n  border: 1px solid #fecaca;\r\n  padding: 10px 14px;\r\n  border-radius: 6px;\r\n  margin-top: 14px;\r\n  font-size: 14px;\r\n}\r\n\r\n.accept-invite-card .accept-link {\r\n  display: block;\r\n  margin-top: 16px;\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
